import React, { useState } from 'react';
import { Alert, AlertIcon, Button } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { EnvelopeSimple } from 'phosphor-react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { api } from '../../../services/api';
import { useActionToast } from '../../../services/actionToast';
import { FormButton } from '../../buttons/FormButton';
import { InputForm } from '../../inputs/forms/InputForm';

const schema = Yup.object().shape({
  email: Yup.string().email('Informe um email válido').required('Este campo é obrigatório!'),
});

export default function RecoverForm() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [serverError, setServerError] = useState('');
  const toast = useActionToast();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: { email: '' },
  });

  const onSubmit = async (payload: { email: string }) => {
    setMessage('');
    setServerError('');
    try {
      const response = await api.post('/auth/forgot-password', payload);
      const feedback =
        response.data?.msg ||
        'Se o email estiver cadastrado, você receberá um link para redefinir sua senha.';
      setMessage(feedback);
      toast({
        status: 'success',
        title: 'Solicitação enviada',
        description: 'Verifique o email informado para continuar.',
      });
    } catch {
      const feedback = 'Não foi possível enviar a solicitação. Tente novamente.';
      setServerError(feedback);
      toast({ status: 'error', title: 'Solicitação não enviada', description: feedback });
    }
  };

  const onInvalid = () => {
    toast({
      status: 'error',
      title: 'Revise o formulário',
      description: 'Corrija os campos indicados antes de enviar.',
      id: 'recover-form-invalid',
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onInvalid)} noValidate>
      <InputForm
        name="email"
        label="Email"
        placeholder="Digite o email para recuperação"
        register={register}
        errors={errors}
        labelStyles={{ color: 'white' }}
        iconLeft={<EnvelopeSimple />}
        type="email"
        autoComplete="email"
        isRequired
      />
      {message && (
        <Alert status="success" borderRadius="md" mb={4} data-testid="forgot-password-success">
          <AlertIcon />
          {message}
        </Alert>
      )}
      {serverError && (
        <Alert status="error" borderRadius="md" mb={4} role="alert">
          <AlertIcon />
          {serverError}
        </Alert>
      )}
      <FormButton type="submit" width="100%" isLoading={isSubmitting}>
        Enviar link
      </FormButton>
      <Button mt={4} width="100%" variant="ghost" color="white" onClick={() => navigate('/login')}>
        Voltar para o login
      </Button>
    </form>
  );
}
